import { IOccurrence } from "../pages/support/types";
import ApiService from "../services/api";
import { ITicketFile } from "./fetchTickets";

const BASE_URL = import.meta.env.VITE_API_TAS;

type FetchOccurrencesParams = {
  searchTerm?: string | null;
  status?: string | null;
  responsible?: string | null;
  subject?: string | null;
  dn?: string | null;
  page?: number;
  size?: number;
  id?: string;
};

export type FileAttachmentSimple = {
  fileId: string;
  key: string;
  name: string;
  url: string;
  fileType: string;
  fileSize: number;
  updatedAt: string;
};

export type FileAttachment = {
  fileId: string;
  key: string;
  name: string;
  url: string;
  fileType: string;
  fileSize: number;
  uploadedAt: string;
  uploadedById: string;
  uploadedBy: string;
};

export const fetchOccurrences = async (
  params?: FetchOccurrencesParams,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const queryParams = new URLSearchParams();

    if (params?.searchTerm) queryParams.append("searchTerm", params.searchTerm);
    if (params?.status) queryParams.append("status", params.status);
    if (params?.responsible)
      queryParams.append("responsible", params.responsible);
    if (params?.dn) queryParams.append("dn", params.dn);
    if (params?.subject) queryParams.append("subject", params.subject);

    // defaults
    queryParams.append("page", String(params?.page ?? 0));
    queryParams.append("size", String(params?.size ?? 100));

    const url = `${BASE_URL}/tas-occurrences?${queryParams.toString()}`;

    const response = await apiService.get<any>(url);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar ocorrencias");
  } catch (error) {
    console.error("Error fetching steps:", error);
    throw error;
  }
};

export const fetchOccurrencesBigNumber = async (
  params?: FetchOccurrencesParams,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const queryParams = new URLSearchParams();

    if (params?.searchTerm) queryParams.append("searchTerm", params.searchTerm);
    if (params?.status) queryParams.append("status", params.status);
    if (params?.responsible)
      queryParams.append("responsible", params.responsible);
    if (params?.dn) queryParams.append("dn", params.dn);
    if (params?.subject) queryParams.append("subject", params.subject);

    const url = `${BASE_URL}/tas-occurrences/status-count?${queryParams.toString()}`;

    const response = await apiService.get<any>(url);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar ocorrencias");
  } catch (error) {
    console.error("Error fetching steps:", error);
    throw error;
  }
};

export const fetchOccurrencesDetail = async (id: string): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${id}`;

    const response = await apiService.get<any>(url);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar ocorrencias");
  } catch (error) {
    console.error("Error fetching steps:", error);
    throw error;
  }
};

export const fetchComments = async (occurrenceId: string): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${occurrenceId}/comments`;

    const response = await apiService.get<any>(url);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar chat da ocorrência");
  } catch (error) {
    console.error("Error fetching tas occurrence chat:", error);
    throw error;
  }
};

export const createComment = async (
  occurrenceId: string,
  comment: string,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${occurrenceId}/comments`;

    const response = await apiService.post<any>(url, { comment });

    if (response.status === 201) {
      return response.data;
    }

    throw new Error("Erro ao criar chat da ocorrência");
  } catch (error) {
    console.error("Error creating tas occurrence chat:", error);
    throw error;
  }
};

export const updateComment = async (
  occurrenceId: string,
  commentId: string,
  comment: string,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${occurrenceId}/comments/${commentId}`;

    const response = await apiService.put<any>(url, { comment });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao atualizar chat da ocorrência");
  } catch (error) {
    console.error("Error updating tas occurrence chat:", error);
    throw error;
  }
};

export const deleteComment = async (
  occurrenceId: string,
  commentId: string,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${occurrenceId}/comments/${commentId}`;

    const response = await apiService.delete<any>(url);

    if (response.status === 204) {
      return response.data;
    }

    throw new Error("Erro ao deletar chat da ocorrência");
  } catch (error) {
    console.error("Error deleting tas occurrence chat:", error);
    throw error;
  }
};

export const edithOccurrencesDetail = async (
  id: string,
  payload: IOccurrence,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/tas-occurrences/${id}`;

    const response = await apiService.put<any>(url, payload);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar ocorrencias");
  } catch (error) {
    console.error("Error fetching steps:", error);
    throw error;
  }
};

export const fetchUsers = async (
  params?: FetchOccurrencesParams,
): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/support/users/fleet-admin`;
    const queryParams = new URLSearchParams();

    if (params?.searchTerm) queryParams.append("searchTerm", params.searchTerm);

    const response = await apiService.get<any>(url);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Erro ao buscar chat da ocorrência");
  } catch (error) {
    console.error("Error fetching tas occurrence chat:", error);
    throw error;
  }
};

export const uploadFileSupport = async ({
  path,
  file,
}: {
  path: string;
  file: File[];
}): Promise<boolean> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);
  const formData = new FormData();
  console.log(file);
  file.forEach((file) => formData.append("file", file));

  try {
    const url = `${BASE_URL}/files/tas-occurrences/${path}`;
    const response = await apiService.post<void>(url, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (response.status < 400) {
      return true;
    } else {
      console.warn("Unexpected status code:", response.status);
      return false;
    }
  } catch (error) {
    console.error("Error uploading ticket image:", error);
    return false;
  }
};

export const fetchFilesSupport = async (path: string): Promise<any> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);
  try {
    const url = `${BASE_URL}/files/tas-occurrences/${path}`;
    const response = await apiService.get<any>(url);
    if (response.status < 400) {
      return response.data;
    } else {
      console.warn("Unexpected status code:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching ticket images:", error);
    return [];
  }
};

export const downloadFile = async (
  id: string,
  fileId: string,
): Promise<Blob | null> => {
  if (!fileId) return null;

  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/files/tas-occurrences/${id}/download/${fileId}`;

    const response = await apiService.get<Blob>(url, {
      responseType: "blob",
    });

    if (response.status < 400) {
      return response.data;
    }

    return null;
  } catch (error) {
    console.error("Error downloading file:", error);
    return null;
  }
};

export const removeFile = async (
  id: string,
  fileId: string,
): Promise<boolean> => {
  const apiService = new ApiService(import.meta.env.VITE_API_TAS);

  try {
    const url = `${BASE_URL}/files/tas-occurrences/${id}/${fileId}`;
    const response = await apiService.delete<void>(url);
    if (response.status < 400) {
      return true;
    } else {
      console.warn("Unexpected status code:", response.status);
      return false;
    }
  } catch (error) {
    console.error("Error removing ticket image:", error);
    return false;
  }
};

export const fetchSupportRegionals = async (): Promise<any> => {
    const apiService = new ApiService(import.meta.env.VITE_API_TAS);

    const url = `${BASE_URL}/support/regionals`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}
